import { fetchDashboard } from "@/api/providerDashboard";
import dashboardLifecycle from "@/controllers/dashboardLifecycle";
import scheduleStatusPresentationMethods from "@/controllers/scheduleStatusPresentationMethods";

export default {
  data() {
    return {
      stats: {
        todayScheduleCount: 0,
        pendingEstimateCount: 0,
        monthlyReceivedEstimateCount: 0,
        recentReviewCount: 0,
        unreadNotificationCount: 0,
        todaySchedules: [],
      },
    };
  },
  ...dashboardLifecycle,
  methods: {
    ...scheduleStatusPresentationMethods,
    async loadDashboard() {
      try {
        const res = await fetchDashboard();
        if (res.data.status === 200) {
          this.stats = res.data.data;
          this.$store.commit("SET_DASHBOARD_COUNTS", res.data.data);
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
